import React from 'react'
import { HashLoader } from 'react-spinners'
import { Spinner } from '../Spinner'
// https://www.npmjs.com/package/react-spinners

import { LoadingStyle } from './style'
//import { VARIABLES } from 'themes'

export class Loading extends React.PureComponent {
  render() {
    const { loading, spinner } = this.props
    return loading ? (
      <LoadingStyle className="loading-wrapper loading">
        {/* <HashLoader loading color="blue" /> */}
        {spinner && <Spinner />}
      </LoadingStyle>
    ) : null
  }
}
